module.exports = {
  title: '会员等级',
  route: {
    path: '/user-manage',
    children: {
      path: 'member-grade',
    },
  },
};
